<div class="ade-pesquisa flex flex-col w-full">
  <header class="ade-pesquisa__header">
    <h1 class="ade-pesquisa__title">{{ "Pesquisa" | transloco }}</h1>

    <form class="ade-pesquisa__form" (ngSubmit)="onSearch(searchQuery)">
      <input
        type="text"
        class="ade-pesquisa__input"
        name="s"
        [(ngModel)]="searchQuery"
        [placeholder]="'Pesquisar veículos...' | transloco"
      />
      <button type="submit" class="ade-pesquisa__submit">
        {{ "Pesquisar" | transloco }}
      </button>
    </form>
  </header>

  <section class="ade-pesquisa__content">
    <div class="ade-pesquisa__count" *ngIf="!isLoading">
      {{ numFound }} {{ "resultados" | transloco }}
      <ng-container *ngIf="searchQuery">
        {{ "para" | transloco }} "{{ searchQuery }}"</ng-container
      >
    </div>

    <div class="ade-pesquisa__loading" *ngIf="isLoading">
      <mat-spinner diameter="48"></mat-spinner>
    </div>

    <ng-container *ngIf="!isLoading">
      <div
        class="ade-pesquisa__grid"
        *ngIf="products.length > 0; else noResults"
      >
        <ade-classified-card
          *ngFor="let product of products"
          [item]="product"
        ></ade-classified-card>
      </div>
      <ng-template #noResults>
        <div class="ade-pesquisa__empty">
          {{ "Sem resultados." | transloco }}
        </div>
      </ng-template>
    </ng-container>
  </section>

  <div class="ade-listing__pagination" *ngIf="!isLoading && pageCount > 1">
    <button
      class="ade-listing__page-btn"
      type="button"
      [disabled]="page.pageIndex === 1"
      (click)="goToPage(page.pageIndex - 1)"
    >
      {{ "ANTERIOR" | transloco }}
    </button>

    <span class="ade-listing__page-info"
      >{{ page.pageIndex }} / {{ pageCount }}</span
    >

    <button
      class="ade-listing__page-btn"
      type="button"
      [disabled]="page.pageIndex === pageCount"
      (click)="goToPage(page.pageIndex + 1)"
    >
      {{ "SEGUINTE" | transloco }}
    </button>
  </div>
</div>
